import React from "react";

const Header = () => {
  return (
    <header className="header">
      <div className="header-logos">
        <img src="./logo-inra.png" alt="Logo 1" className="logo1" />
        <img src="./ministere.png" alt="Logo 6" className="logo6" />
        <img src="./images.png" alt="Logo 3" className="logo3" />
        <img src="./logo/UM6P.png" alt="Logo 4" className="logo5" />
      </div>
      <div className="header-logos-petit">
        <img src="./logo/ada.png" alt="Logo 5" className="logo5" />
        <img src="./logo/ANDZOA.png" alt="Logo 4" className="logo5" />
        <img src="./aryam.png" alt="Logo 4" className="logo7" />
        <img src="./icarda.png" alt="Logo 4" className="logo5" />
      </div>
    </header>
  );
};

export default Header;
